import React, { useEffect, useState } from 'react';

/* Godišnje doba oko logoa u zaglavlju (po današnjem datumu, astronomski početci za Srbiju):
   proleće 20.3. (grana koja cveta, latice, leptir), leto 21.6. (zraci sunca, talas, iskre),
   jesen 23.9. (lišće koje pada, nalet vetra, gomilica lišća), zima 21.12. (sneg na globusu, pahulje, inje;
   15.12–14.1. i praznične lampice). Čestice (latice, iskre, lišće, pahulje) idu preko celog brenda, a naziv ima
   sezonski odsjaj koji prelazi preko slova. Sve je dekoracija (aria-hidden), uz "smanji pokret" ostaje mirna scena.
   Pregled drugog doba: ?sezona=prolece|leto|jesen|zima */

const LOGO = '/images/logo/tacho-logo.png';
const CX = 28, CY = 32; // centar globusa u sceni 56 x 64 (logo je 40 px, r = 20)

const DOBA = {
    prolece: { naziv: 'Proleće', sledece: 'leta' },
    leto: { naziv: 'Leto', sledece: 'jeseni' },
    jesen: { naziv: 'Jesen', sledece: 'zime' },
    zima: { naziv: 'Zima', sledece: 'proleća' },
};
const POCECI = [[3, 20, 'prolece'], [6, 21, 'leto'], [9, 23, 'jesen'], [12, 21, 'zima']];

export function sezonaZa(d) {
    const md = (d.getMonth() + 1) * 100 + d.getDate();
    if (md >= 320 && md < 621) return 'prolece';
    if (md >= 621 && md < 923) return 'leto';
    if (md >= 923 && md < 1221) return 'jesen';
    return 'zima';
}

/** broj dana do početka sledećeg godišnjeg doba */
const danaDoSledeceg = (d) => {
    const danas = new Date(d.getFullYear(), d.getMonth(), d.getDate());
    const kandidati = POCECI.flatMap(([m, dan]) => [new Date(d.getFullYear(), m - 1, dan), new Date(d.getFullYear() + 1, m - 1, dan)]);
    const sledeci = kandidati.filter((x) => x > danas).sort((a, b) => a - b)[0];
    return Math.round((sledeci - danas) / 86400000);
};
const praznici = (d) => { const md = (d.getMonth() + 1) * 100 + d.getDate(); return md >= 1215 || md <= 114; };
const dana = (n) => (n % 10 === 1 && n % 100 !== 11 ? `${n} dan` : `${n} dana`);

const tacka = (r, stepeni) => { const a = (stepeni * Math.PI) / 180; return [CX + r * Math.cos(a), CY + r * Math.sin(a)]; };
const f = (n) => n.toFixed(2);

/* ---- oblici (računaju se jednom) ---- */
const ZRACI = Array.from({ length: 12 }, (_, i) => {
    const a = i * 30;
    const [x1, y1] = tacka(21, a - 7), [x2, y2] = tacka(i % 2 ? 27 : 30, a), [x3, y3] = tacka(21, a + 7);
    return `M${f(x1)} ${f(y1)}L${f(x2)} ${f(y2)}L${f(x3)} ${f(y3)}Z`;
}).join('');

/* kapa snega: spoljni luk preko vrha globusa, donja ivica talasasta (kao da se sneg sliva) */
const KAPA = (() => {
    const od = -158, ddo = -22;
    const [sx, sy] = tacka(21.2, od), [ex, ey] = tacka(21.2, ddo);
    let d = `M${f(sx)} ${f(sy)}A21.2 21.2 0 0 1 ${f(ex)} ${f(ey)}`;
    for (let a = ddo; a >= od; a -= 4) {
        const r = 17.4 - 1.6 * Math.max(0, Math.sin(((a + 22) / 136) * Math.PI * 4.5)) + (a === ddo || a <= od + 3 ? 3.6 : 0);
        const [x, y] = tacka(r, a);
        d += `L${f(x)} ${f(y)}`;
    }
    return d + 'Z';
})();
const KAPA_SJAJ = (() => { const [sx, sy] = tacka(19.6, -140), [ex, ey] = tacka(19.6, -95); return `M${f(sx)} ${f(sy)}A19.6 19.6 0 0 1 ${f(ex)} ${f(ey)}`; })();

const LAMPICE = Array.from({ length: 7 }, (_, i) => tacka(22.5, 155 - i * 21.7));
const ZICA = (() => { const [sx, sy] = tacka(22, 162), [ex, ey] = tacka(22, 18); return `M${f(sx)} ${f(sy)}A22 22 0 0 0 ${f(ex)} ${f(ey)}`; })();

const LIST = 'M5 0L6.1 2.9 9 2 7.6 4.9 10 6.1 6.6 6.9 6.2 10 5 8.4 3.8 10 3.4 6.9 0 6.1 2.4 4.9 1 2 3.9 2.9Z';
const PAHULJA = 'M5 0V10M.7 2.5 9.3 7.5M.7 7.5 9.3 2.5M3.6.6 5 1.8 6.4.6M3.6 9.4 5 8.2 6.4 9.4';
const CVET = [0, 72, 144, 216, 288];

/* čestice preko celog brenda (logo + naziv): x (% širine), kašnjenje, trajanje, veličina, drift (px) */
const raspored = (n, seme, [tMin, tMax], [sMin, sMax], dx) => Array.from({ length: n }, (_, i) => {
    const r = (k) => { const x = Math.sin((i + 1) * 12.9898 * k + seme) * 43758.5453; return x - Math.floor(x); };
    return [Math.round(((i + 0.2 + r(1) * 0.6) / n) * 100), +(r(2) * tMax).toFixed(1), +(tMin + r(3) * (tMax - tMin)).toFixed(1),
        +(sMin + r(4) * (sMax - sMin)).toFixed(2), Math.round((r(5) - 0.35) * dx)];
});
const CESTICE = {
    prolece: raspored(9, 1.7, [7, 10], [0.7, 1.05], 30),
    leto: raspored(8, 4.2, [5, 8], [0.5, 1], 14),
    jesen: raspored(10, 2.9, [6, 9], [0.75, 1.1], 34),
    zima: raspored(16, 3.3, [6, 9.5], [0.55, 1], 16),
};

function Cestice({ doba }) {
    return (
        <span className="sez-cestice" aria-hidden="true">
            {CESTICE[doba].map(([x, k, t, s, dx], i) => (
                <span key={i} className="sez-c" style={{ left: `${x}%`, animationDelay: `-${k}s`, animationDuration: `${t}s`, '--sez-dx': `${dx}px` }}>
                    <span className={`sez-c-in sez-c-${i % 3}`} style={{ animationDelay: `-${k}s`, scale: String(s) }}>
                        {doba === 'prolece' && <i className="sez-latica" />}
                        {doba === 'leto' && <svg viewBox="0 0 10 10" width="7" height="7"><path d="M5 0Q5 5 10 5Q5 5 5 10Q5 5 0 5Q5 5 5 0Z" /></svg>}
                        {doba === 'jesen' && <svg viewBox="0 0 10 10" width="9" height="9"><path d={LIST} /></svg>}
                        {doba === 'zima' && (i % 2
                            ? <i className="sez-pahuljica" />
                            : <svg viewBox="-1 -1 12 12" width="8" height="8"><path d={PAHULJA} /></svg>)}
                    </span>
                </span>
            ))}
        </span>
    );
}

/** scena iza logoa */
function Pozadina({ doba }) {
    return (
        <svg className="sez-iza" viewBox="0 0 56 64" aria-hidden="true">
            <defs>
                <radialGradient id="sez-sjaj">
                    <stop offset="55%" className="sez-sjaj-1" />
                    <stop offset="100%" className="sez-sjaj-2" />
                </radialGradient>
            </defs>
            <circle cx={CX} cy={CY} r="28" fill="url(#sez-sjaj)" className="sez-oreol" />
            {doba === 'leto' && <g className="sez-zraci"><path d={ZRACI} /></g>}
            {doba === 'zima' && <circle cx={CX} cy={CY} r="24.5" className="sez-inje" />}
        </svg>
    );
}

/** scena ispred logoa */
function Prednji({ doba, lampice }) {
    if (doba === 'prolece') return (
        <svg className="sez-ispred" viewBox="0 0 56 64" aria-hidden="true">
            <g className="sez-grana">
                <path className="sez-grana-drvo" d="M-2 63C6 60 10 55 16 54.5S25 57 30 55" />
                <path className="sez-grana-drvo tanka" d="M10 57.5C9 54 10.5 51 13 49.5" />
                <path className="sez-listic" d="M22 56c2-3 5-3.5 6.5-2.5-1.5 2.5-4 3.5-6.5 2.5z" />
                <path className="sez-listic" d="M6 60.5c-.5-3 1.5-5 3.5-5.2-.2 2.6-1.5 4.3-3.5 5.2z" />
                {[[13, 49], [18, 54.2], [30.5, 54.6], [4, 58.5]].map(([x, y], i) => (
                    <g key={i} className="sez-cvet" style={{ transformOrigin: `${x}px ${y}px`, animationDelay: `${0.3 + i * 0.35}s` }}>
                        {CVET.map((a) => <ellipse key={a} cx={x} cy={y - 2} rx="1.45" ry="2.1" transform={`rotate(${a} ${x} ${y})`} />)}
                        <circle cx={x} cy={y} r=".95" className="sez-cvet-srce" />
                    </g>
                ))}
            </g>
        </svg>
    );
    if (doba === 'leto') return (
        <svg className="sez-ispred sez-more" viewBox="0 0 56 64" aria-hidden="true">
            <path className="sez-talas zadnji" d="M-28 56q3.5-2.6 7-0t7 0 7 0 7 0 7 0 7 0 7 0 7 0 7 0 7 0 7 0 7 0 7 0V66H-28Z" />
            <path className="sez-talas" d="M-28 58q3.5-2.6 7-0t7 0 7 0 7 0 7 0 7 0 7 0 7 0 7 0 7 0 7 0 7 0 7 0V66H-28Z" />
        </svg>
    );
    if (doba === 'jesen') return (
        <svg className="sez-ispred" viewBox="0 0 56 64" aria-hidden="true">
            <path className="sez-vetar" d="M-6 22C8 16 18 27 32 21S50 13 62 18" />
            <path className="sez-vetar drugi" d="M-6 40C10 35 20 45 34 39S52 33 62 37" />
            <g className="sez-gomila">
                <path className="sez-gl-0" d={LIST} transform="translate(38 53) rotate(-18 5 5) scale(.8)" />
                <path className="sez-gl-1" d={LIST} transform="translate(44 54.5) rotate(24 5 5) scale(.75)" />
                <path className="sez-gl-2" d={LIST} transform="translate(41 56.5) rotate(70 5 5) scale(.7)" />
            </g>
        </svg>
    );
    return (
        <svg className="sez-ispred" viewBox="0 0 56 64" aria-hidden="true">
            <path className="sez-kapa" d={KAPA} />
            <path className="sez-kapa-sjaj" d={KAPA_SJAJ} />
            {lampice && (
                <g className="sez-lampice">
                    <path className="sez-zica" d={ZICA} />
                    {LAMPICE.map(([x, y], i) => <circle key={i} cx={x} cy={y} r="1.7" className={`sez-lampica l${i % 4}`} style={{ animationDelay: `${(i * 0.37) % 2.2}s` }} />)}
                </g>
            )}
        </svg>
    );
}

/** leptir koji kruži oko globusa (proleće) i iskre (leto) */
function Ukras({ doba }) {
    if (doba === 'prolece') return (
        <span className="sez-leptir" aria-hidden="true">
            <svg viewBox="0 0 12 10" width="11" height="9">
                <g className="sez-krila"><path d="M6 5C3 0 0 1 1.5 4.6 0 8 3 9.6 6 5Z" /><path d="M6 5C9 0 12 1 10.5 4.6 12 8 9 9.6 6 5Z" /></g>
                <path className="sez-telo" d="M6 2.2V8" />
            </svg>
        </span>
    );
    if (doba === 'leto') return (
        <svg className="sez-iskre" viewBox="0 0 56 64" aria-hidden="true">
            {[[5, 10, 0], [50, 14, 0.9], [52, 46, 1.7], [3, 42, 2.4]].map(([x, y, k], i) => (
                <path key={i} style={{ transformOrigin: `${x}px ${y}px`, animationDelay: `${k}s` }}
                    d={`M${x} ${y - 3}Q${x} ${y} ${x + 3} ${y}Q${x} ${y} ${x} ${y + 3}Q${x} ${y} ${x - 3} ${y}Q${x} ${y} ${x} ${y - 3}Z`} />
            ))}
        </svg>
    );
    return null;
}

export default function Sezona({ children }) {
    const [danas, setDanas] = useState(() => new Date());
    useEffect(() => { const t = setInterval(() => setDanas(new Date()), 3600000); return () => clearInterval(t); }, []);

    const pregled = new URLSearchParams(window.location.search).get('sezona');
    const doba = DOBA[pregled] ? pregled : sezonaZa(danas);
    const lampice = doba === 'zima' && (pregled === 'zima' || praznici(danas));
    const naslov = DOBA[pregled]
        ? `${DOBA[doba].naziv} (pregled)`
        : `${DOBA[doba].naziv} · još ${dana(danaDoSledeceg(danas))} do ${DOBA[doba].sledece}`;

    return (
        <div className={`brand sez-brand sez-brand-${doba}`} title={naslov}>
            <span className={`sezona sezona-${doba}`}>
                <Pozadina doba={doba} />
                <img className="sez-logo" src={LOGO} alt="" />
                <Prednji doba={doba} lampice={lampice} />
                <Ukras doba={doba} />
            </span>
            {children}
            <Cestice doba={doba} />
        </div>
    );
}
